import { render, staticRenderFns } from "./addons.vue?vue&type=template&id=04273316&"
import script from "./addons.vue?vue&type=script&lang=js&"
export * from "./addons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports